import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { jwtDecode } from 'jwt-decode';
import { api } from '../../config';
import "./Article.css";
import { toast } from 'react-toastify';
const ArticleForm = ({ArticleForm}) => {
  const [authors, setAuthors] = useState([]);
  const [relatedBooks, setRelatedBooks] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showNewAuthorForm, setShowNewAuthorForm] = useState(false); // State to toggle new author form
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    article_name: '',
    article_url: '',
    author_id:   '',
    journal_id:   '',
    article_id:   '',
    author_name: '',
    isUpdating:  false
  });
  //invoke  getters if the ArticleForm is true

  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username); // Check if username exists in localStorage
    checkTokenExpiration();
    if (ArticleForm) { 
      getAuthors();
     getRelatedBooks();
     
   }
  }, []);
  const checkTokenExpiration = () => {
    const token = localStorage.getItem('token');
    //console.log("token");
    //console.log(token);
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert milliseconds to seconds
      //console.log("decodedToken");
      //console.log(decodedToken);
      if (decodedToken.exp < currentTime) {
        // Token has expired, clear it from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('username');
      }
    }else{
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('username');
    }
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username); // Check if username exists in localStorage
    
  };



  const getAuthors = async () => {
    try {
      const response = await fetch(`${api}/book_author/authors`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });
       let data = await response.json();
        //console.log(data);
        setAuthors(data);
        
      }
     
     catch (error) {
      //console.log(error);
    }
  }
  const handleAddNewAuthor = async () => {
    setShowNewAuthorForm(true);
  }
  const getRelatedBooks = async () => {
    try {
      const response = await fetch(`${api}/book_author/related_journal`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          }
        });
       let data = await response.json();
        //console.log(data);
        setRelatedBooks(data);
      }
     
     catch (error) {
      //console.log(error);
    }
  }

  const handleChange = (event, newValue, name) => {
    // If newValue is not null and it's an object with the id property
    if(newValue && newValue.hasOwnProperty('author_id')){
      setFormData({
        ...formData,
        [name]: newValue.author_id
      });
    } else if(newValue && newValue.hasOwnProperty('book_id')){
      setFormData({
        ...formData,
        [name]: newValue.book_id
      });
    } else {
      // Handle the case where newValue is null (no selection)
      setFormData({
        ...formData,
        [name]: newValue ?? event.target.value
      });
    }
  };
  
  useEffect(() => {
    setFormData({
      article_name:ArticleForm?.article_name,
      article_url: ArticleForm?.article_url  ,
      author_id:   ArticleForm?.author_id      ,
      journal_id:  ArticleForm?.journal_id   ,
      article_id:  ArticleForm?.article_id  ,
      isUpdating:  ArticleForm?.isUpdating   ,
    });
  },[ArticleForm])
  const handleSubmit = async (event) => {
    event.preventDefault();
    //console.log("formData",formData);
    const method = formData.isUpdating ? 'PUT' : 'POST';
   
    //append token too
    const token = localStorage.getItem('token');
    if (token) {
      formData.token = token;
    }
    const response = await fetch(`${api}/book_author/article${formData.isUpdating ? '/' + formData.article_id : ''}`, {
      method,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    //tosater of respon
    const data = await response.json();
    //console.log(data);
    if(data.message == "article created successfully"){
        toast.success('تم اضافة المقال بنجاح');
    }
    if(data.message == "article updated successfully"){
        toast.success('تم تحديث المقال بنجاح');
    }
    resetForm();
  };

  const handleUpdateOrDelete = async (updateMode, articleId) => {
    if (updateMode) {
      const article = articles.find(article => article.id === articleId);
      setFormData({
        ...article,
        author_id: article.author.author_id,
        journal_id: article.relatedBook.book_id
      });
    } else {
      await fetch(`${api}/book_author/article/${articleId}`, {
        method: 'DELETE'
      });
      setArticles(articles.filter(article => article.id !== articleId));
      resetForm();

    }
  };

  const resetForm = () => {
    setFormData({
      article_name: '',
      article_url: '',
      author_id: '',
      journal_id: '',
      isUpdating: false
    });
    
  };
  
  
  const handleSubmitNewAuthor = async (e) => {
    e.preventDefault();
    
    const token = localStorage.getItem('token');
    if (!token) {
        // Handle the case when token is null (e.g., redirect to login page)
        //console.log('User is not authenticated. Redirecting to home page...');
        window.location.href = '/index';
        // Redirect logic or display unauthorized message
        return;
    }
    let decodedToken ='';
    if (token) {
       decodedToken = (token);
    }
    try {
      const response = await fetch(`${api}/book_author/newAuthor`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${decodedToken}` 
          },
          body: JSON.stringify({
            name: formData.author_name,

            token:decodedToken,
          }
          ),
        });
       let data = await response.json();
       
       //console.log(data);
       if (data.message === "Author: Firstname Lastname successfully") {
        //console.log("      <ToastContainer />");
        toast.success('تم إضافة المؤلف بنجاح');
        setAuthors(prevAuthors => [...prevAuthors]);

      }
     
        //console.log(data);
      }
     
     catch (error) {
      //console.log(error);
    }
    
    setShowNewAuthorForm(false); 
    getAuthors();
    
  }

  const handleOpen = () => {
 
      const username = localStorage.getItem('username');
      setIsLoggedIn(!!username); // Check if username exists in localStorage
      checkTokenExpiration();
      getAuthors();
      getRelatedBooks();
      setShowForm(true);
  };

  return (
    <span>
      {(showForm || formData.isUpdating) ? (

         <form className='book-details-form' onSubmit={handleSubmit}>
      <div className='book-details-form-item'>
          <label> أسم المقال<span style={{ color: 'red' }}>*</span></label>
            <input type='text' name='article_name' value={formData.article_name} onChange={(e) => handleChange(e, null, 'article_name')} />
          </div>
      <div className='book-details-form-item'>
          <label> رابط المقال<span style={{ color: 'red' }}>*</span></label>
            <input type='text' name='article_url' value={formData.article_url} onChange={(e) => handleChange(e, null, 'article_url')} />
          </div>
          <div className='book-details-form-item'>
             <label>تأليف<span style={{ color: 'red' }}>*</span></label>
             <Autocomplete
                id="author_id"
                options={authors}
                value={authors.find(author => author.author_id === formData.author_id) || null}
                getOptionLabel={(option) => option?.author_name || ''}
                onChange={(event, newValue) => handleChange(event, newValue, 'author_id')}
                renderInput={(params) => <TextField {...params} />}
                />

           </div>
           <div className='form-buttons'>
           {!showNewAuthorForm && (
               <button type='button' onClick={handleAddNewAuthor}>إضافة مؤلف جديد</button>
             )}
           </div>
           {showNewAuthorForm && (
             <>
               <div className='book-details-form-item'>
                 <label>اسم الكاتب:</label>
                 <input type='text' name='author_name' value={formData.author_name} onChange={(e) => handleChange(e, null, 'author_name')} />
               </div>
            
               <div className='form-buttons'>
                 <button onClick={handleSubmitNewAuthor}> إضافة المؤلف</button>
                 <button onClick={() => setShowNewAuthorForm(false)}>الغاء</button>
               </div>
             </>
           )}
      <div className='book-details-form-item'>
             <label>  العدد<span style={{ color: 'red' }}>*</span></label>
             <Autocomplete
                id="journal_id"
                options={relatedBooks}
                value={relatedBooks.find(book => book.book_id === formData.journal_id) || null}
                getOptionLabel={(option) => option?.title || ''}
                onChange={(event, newValue) => handleChange(event, newValue, 'journal_id')}
                renderInput={(params) => <TextField {...params} />}
                />

           </div>
      <div className='form-buttons'>
        <button  type="submit">{formData.isUpdating ? 'تحديث' : 'إضافة'}</button>
        <button  type="button" onClick={() => {setShowForm(false); resetForm()}}> الغاء</button>
        {formData.isUpdating && (
          <button  type="button" onClick={() => handleUpdateOrDelete(false, formData.article_id)} color="error">حذف</button>
        )}
    
        </div>    
      
      </form>
    ) : (
      // dont show if ArticleForm is true
      !ArticleForm && !formData.isUpdating && (
        
          <button className="new-book-btn" onClick={() => handleOpen()}> إضافة بحث  </button>
       
      )
        
    )}  
    </span>
  );
};

export default ArticleForm;
